import { apiRequest } from './client';
import type { UUID } from '@/types';

export type UsageParams = {
  groupBy?: 'tenant' | 'user' | 'number' | 'provider' | 'date';
  preset?: string;
  from?: string;
  to?: string;
  userId?: string;
  limit?: number;
  offset?: number;
};

export type UsageDateItem = {
  day: string;
  calls: number;
  duration_seconds?: number;
};

export type UsageResponse = {
  group_by: string;
  range?: { from: string | null; to: string | null };
  items: UsageDateItem[];
  limit?: number;
  offset?: number;
};

function toQuery(params?: UsageParams): string {
  const qs = new URLSearchParams();
  if (!params) return '';
  if (params.groupBy) qs.set('groupBy', params.groupBy);
  if (params.preset) qs.set('preset', params.preset);
  if (params.from) qs.set('from', params.from);
  if (params.to) qs.set('to', params.to);
  if (params.userId) qs.set('userId', params.userId);
  if (params.limit != null) qs.set('limit', String(params.limit));
  if (params.offset != null) qs.set('offset', String(params.offset));
  const query = qs.toString();
  return query ? `?${query}` : '';
}

export const usageApi = {
  getTenantUsage(tenantId: UUID, params?: UsageParams): Promise<UsageResponse> {
    return apiRequest(`/api/v1/tenants/${tenantId}/usage${toQuery(params)}`, {
      tenantId,
    });
  },

  getPlatformUsage(params?: UsageParams & { tenantId?: string }): Promise<UsageResponse> {
    return apiRequest(`/api/v1/platform/usage${toQuery(params)}`);
  },
};
